import ReactEcharts from 'echarts-for-react';
import React from 'react';
import sizeAware from '../../../SizeAware';
import updatePreventer from '../../../../UpdatePreventer';
import { toast } from 'react-toastify';
import ColorPicker from '../../../../Colorpicker/index-beta';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

class BarChart extends React.Component {
  constructor(props) {
    super(props);
    const { error } = this.props;

    this.chartRef = React.createRef();
    this.updateOptions = this.updateOptions.bind(this);
    this.configurationError = error;

    this.colorPickerRef = React.createRef();
    this.manager = useChartManagement(this);
  }

  // ShouldComponentUpdate criado para atualizar o echarts de modo
  // a não ré-renderizar o gráfico em sí, que é o que estava
  // causando erro ao habilitar/desabilitar uma legenda no gráfico
  // pois a refererência do echarts era perdida.
  shouldComponentUpdate(nextProps, nextState) {
    return this.manager.changesChecker(nextProps);
  }

  onChartReady(echarts) {
    this.echarts = echarts;
  }

  /**
   * onResize callback. This implementation detects the current chart size
   * and selects the correct label formatter accordingly.
   *
   * currently, we maintain two types of label formatter:
   *
   * 1. one that shows all the bar chart labels
   * 2. one that shows only the first bar chart label
   *
   * why is that? when the chart contains a high number of bars and the chart size
   * is not big enough, the label on top of each bar starts to overlap each other,
   * so the team (together with the PO) decided to show only the label of the first bar
   * which is good enough to maintain a size reference to compare to the other bars.
   *
   * @param {newWidth, newHeight, resolution} settings
   */
  onResize(settings) {
    this.manager.onResize(settings);
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possivel abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    toast.error(this.configurationError.toString());
  }

  /**
   * atualiza as configuracoes da instancia de echarts
   * passada.
   */
  updateOptions(newOptions) {
    this.setState((prevState) => ({
      ...prevState,
      options: {
        ...prevState.options,
        ...newOptions,
      },
    }));
  }

  render() {
    const { colorPickerColors, chartRef } = this.props;

    return (
      <>
        <ReactEcharts
          option={this.manager.getOptions()}
          onChartReady={(echarts) => this.onChartReady(echarts)}
          onEvents={{
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
            dblclick: (ctx) => this.manager.handleOnDoubleClick(ctx),
          }}
          ref={(echarts) => {
            chartRef.current = echarts;
            this.chartRef = echarts;
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
      </>
    );
  }
}

/**
 * NOTES:
 *
 * 1. the name of the function must be THE SAME
 * name of the props you want to avoid re-render in case
 * it changes. The function is called whenever the prop
 * with the same name changes. The function receives to params:
 * the previous and the next state of the prop.
 *
 * 2. the "this" context inside the function will be the
 * wrapped/decored component itself. So you can call this.props,
 * this.someCustomFunction as you wish.
 */
const settings = {};

export default sizeAware(updatePreventer(settings, BarChart));
